export default function Card({
  children,
  padding = '18px 20px',
  style = {},
  onClick,
  hover = false,
}) {
  return (
    <div
      onClick={onClick}
      style={{
        background: 'var(--color-bg-primary)',
        border: '0.5px solid var(--color-border-light)',
        borderRadius: 'var(--radius-lg)',
        padding,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'border-color 0.15s',
        ...style,
      }}
      onMouseEnter={e => {
        if (hover || onClick) {
          e.currentTarget.style.borderColor = 'var(--color-border-medium)';
        }
      }}
      onMouseLeave={e => {
        if (hover || onClick) {
          e.currentTarget.style.borderColor = 'var(--color-border-light)';
        }
      }}
    >
      {children}
    </div>
  );
}